import MLModelsPage from '../screens/MLModelsPage';
import * as React from 'react';
import { ProtectedRoute } from '../../common/components';

export const MlModelsPagesNavigation = {
    MLModelsPage: '/projects/:id/mlmodels'
};

export default () => {
    return (
        <React.Fragment>
            <ProtectedRoute component={MLModelsPage} path={MlModelsPagesNavigation.MLModelsPage} />
        </React.Fragment>
    );
};
